import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import type { LinkActionProps } from '../shared/types';

const DefaultLink = forwardRef<HTMLAnchorElement, LinkActionProps>(({ action, children, ...restProps }, ref) => {
    const target = action.openInNewWindow ? { target: '_blank' } : {};
    const rel = action.noFollow ? { rel: 'nofollow' } : {};

    return (
        <Link ref={ref} to={action.url} state={action} reloadDocument {...target} {...rel} {...restProps}>
            {children}
        </Link>
    );
});

export default DefaultLink;
